import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { usePreferences } from "../../hooks/useAccount";
import { useBikes } from "../../hooks/useBikes";

const RequireBike = () => {
  const { data: bikes, isPending, isSuccess } = useBikes(1);
  const {
    data: preferences,
    isSuccess: prefSuccess,
    isPending: prefsPending,
  } = usePreferences();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      isSuccess &&
      bikes?.items.length === 0 &&
      prefSuccess &&
      preferences.selected_bike === undefined
    ) {
      navigate("/bikes/new", { replace: true });
    }
  }, [isSuccess, bikes, prefSuccess, preferences?.selected_bike]);

  if (isPending || bikes?.items.length === 0 || prefsPending) {
    return null;
  }

  return <Outlet />;
};

export default RequireBike;
